import {
  VCard,
  VRow,
  VCol,
  VIcon,
  VBtn,
  VList,
  VListItem,
  VOverlay
} from "vuetify/lib";
import { v4 as uuidv4 } from "uuid";
import Filialen from "@/models/filialen";
import Fischeinheiten from "@/models/fischeinheiten";
import Fisch from "@/models/fisch";
import Wareneinheiten from "@/models/wareneinheiten";
import Verbrauchswaren from "@/models/verbrauchswaren";
import DatumAuswahl from "./components/datumAuswahl";
import BestellungAuswahl from "./components/bestellungAuswahl";
import KundenAuswahl from "./components/kundenAuswahl";
import "./mobileClasses.scss";

export default {
  data() {
    return {
      navDrawer: false,
      users: [],
      filialen: null,
      pointOfSale: null,
      filialeAktuell: this.$store.state.bestellungConfig.store,
      datumAktuell: null,
      customerChoose: false,
      customerChoice: false
    };
  },
  mounted() {},
  methods: {
    customerEdit() {
      this.$router.push({
        path:
          "/" +
          this.$route.params.lang +
          `/mobile/kunden/${this.$store.state.bestellungConfig.customer}`
      });
    },
    customerClose() {
      this.$store.commit("bestellungConfig", {
        key: "savedsearch",
        value: ""
      });
      this.$store.commit("bestellungConfig", {
        key: "customer",
        value: ""
      });
      this.customerChoice = false;
      this.customerChoose = false;
    },
    customerChosen() {
      this.customerChoice = true;
    },
    newItem() {
      this.$store.commit("bestellungConfig", {
        key: "ordermode",
        value: "fishandgoods"
      });
      this.$store.commit("bestellungConfig", {
        key: "rendermode",
        value: "neworder"
      });
      this.$router.push({ path: `./bestellungen/${uuidv4()}` });
    }
  },
  created() {
    if (this.$store.state.bestellungConfig.rendermode == "additem") {
      this.$router.push({ path: `./bestellungen/${uuidv4()}` });
    }
    if (this.$store.state.bestellungConfig.rendermode == "goitem") {
      this.$store.commit("bestellungConfig", {
        key: "rendermode",
        value: "editorder"
      });
      this.$router.push({
        path: `./bestellungen/${this.$store.state.bestellungConfig.lastid}`
      });
    }
    this.filialen = Filialen.all();
    this.pointOfSale = this.filialen.filter(filiale => filiale.verkauf == 1);
    if (this.$store.state.bestellungConfig.customer != "") {
      this.customerChoose = true;
      this.customerChoice = true;
    }
  },
  watch: {
    "$store.state.loading"(value) {
      if (!value) {
        const warenfische = [];
        const fischIds = [];
        const kistendaten = {};

        Fischeinheiten.all().forEach(element => {
          if (fischIds.indexOf(element.fisch) == -1) {
            const fisch = Fisch.find(element.fisch);
            if (fisch && !warenfische.find(e => e.id == fisch.id)) {
              warenfische.push({
                id: fisch.id,
                gruppe: fisch.gruppe,
                name_de: fisch.name_de,
                foto: fisch.foto,
                typ: "fisch"
              });
            }
            kistendaten[element.id] = {
              typ: "fisch",
              name: Fisch.find(element.fisch).name_de,
              chestname: `${element.bezeichnung} (${element.min_gewicht}g - ${element.max_gewicht}g)`,
              plu: `${element.plu ? element.plu : ""}${
                element.plu2 ? ", " + element.plu2 : ""
              }`
            };
          }
        });

        // Waren
        Wareneinheiten.all().forEach(element => {
          if (
            element.verbrauchsware &&
            element.verbrauchsware != "" &&
            element.verbrauchsware != "null" &&
            element.intern != 1
          ) {
            const verbrauchsware = Verbrauchswaren.find(element.verbrauchsware);
            if (verbrauchsware) {
              warenfische.push({
                id: element.id,
                gruppe: element.gruppe,
                name_de: element.bezeichnung,
                foto: verbrauchsware.foto,
                typ: "ware"
              });
              kistendaten[element.id] = {
                typ: "ware",
                name: verbrauchsware.name_de,
                chestname: "",
                plu: `${element.plu ? element.plu : ""}${
                  element.plu2 ? ", " + element.plu2 : ""
                }`
              };
            }
          }
        });
        // für waren und fischauswahl
        this.$store.commit("lookup", {
          key: "warenfische",
          value: warenfische
        });
        // kistensummierung, benennung
        this.$store.commit("lookup", {
          key: "kistendaten",
          value: kistendaten
        });

        // lookups done
        this.$store.commit("lookup", {
          key: "build",
          value: true
        });
      }
    }
  },
  render() {
    const orderPage = {};
    const homeButton =
      this.$store.state.userlevel < 8 ? (
        <VListItem
          onClick={() =>
            this.$router.push({
              path: "/" + this.$route.params.lang + "/home"
            })
          }
        >
          <VIcon class="mr-3">mdi-home</VIcon>
          {this.$t("navigation.home")}
        </VListItem>
      ) : (
        <div />
      );
    orderPage["orders"] = (
      <div>
        {!this.$store.state.lookup.build && (
          <div class="loadingScreen">
            Initialisierung
            <br />
            <span class="loader" />
          </div>
        )}
        {this.navDrawer && (
          <VOverlay value="navDrawer" z-index="10000">
            <VList>
              {homeButton}
              <VListItem
                onClick={() =>
                  this.$router.push({
                    path: "/" + this.$route.params.lang + "/logout"
                  })
                }
              >
                <VIcon class="mr-3">mdi-logout</VIcon>
                {this.$t("navigation.logout")}
              </VListItem>
              <VListItem onClick={() => (this.navDrawer = !this.navDrawer)}>
                <VIcon class="mr-3">mdi-close</VIcon>
                {this.$t("button.cancel")}
              </VListItem>
            </VList>
          </VOverlay>
        )}
        <VCard class="bestellungenCard">
          <BestellungAuswahl />
        </VCard>

        {this.customerChoose && (
          <VCard class="floatingCard">
            <VRow no-gutters class="heading">
              <VCol cols="2" class="pa-2">
                <VBtn fab small>
                  <VIcon color="grey">mdi-card-account-details</VIcon>
                </VBtn>
              </VCol>
              <VCol cols="10" class="pa-2 d-flex justify-end">
                <span class="white--text text-h6 ma-1">
                  {this.$t("header.choosecustomer")}
                </span>
              </VCol>
            </VRow>
            <VRow no-gutters class="mt-0 pa-1">
              <VCol>
                <KundenAuswahl
                  on-customer-chosen={this.customerChosen}
                  on-customer-edit={this.customerEdit}
                />
              </VCol>
            </VRow>
          </VCard>
        )}

        <VRow no-gutters class="heading">
          <VCol cols="1" class="pa-2">
            <VBtn
              width="45"
              height="45"
              fab
              small
              onClick={() => (this.navDrawer = !this.navDrawer)}
            >
              <VIcon color="grey">mdi-dots-vertical</VIcon>
            </VBtn>
          </VCol>
          <VCol cols="11" class="pa-2 d-flex justify-end">
            <DatumAuswahl />
          </VCol>
        </VRow>
        <VRow no-gutters class="mt-2 pa-1 bestellungenFillHeight">
          <VCol></VCol>
        </VRow>
        <VRow class="mt-2 bottomRow" no-gutters>
          <VCol cols="4" align="left">
            {this.customerChoose && (
              <VBtn
                width="90%"
                large
                color="red"
                class="ma-1"
                dark
                onClick={() => this.customerClose()}
              >
                <VIcon large>mdi-close-thick</VIcon>
              </VBtn>
            )}
            {!this.customerChoose && (
              <VBtn
                width="90%"
                large
                color="blue"
                class="ma-1"
                dark
                onClick={() => (this.customerChoose = true)}
              >
                <VIcon large>mdi-account</VIcon>
              </VBtn>
            )}
          </VCol>
          <VCol cols="4" align="left">
            {this.customerChoose && !this.customerChoice && (
              <VBtn
                width="90%"
                large
                color="blue"
                class="ma-1"
                dark
                onClick={() =>
                  this.$router.push({ path: `./kunden/${uuidv4()}` })
                }
              >
                <VIcon large>mdi-account-plus</VIcon>
              </VBtn>
            )}
          </VCol>
          <VCol cols="4" align="right">
            {(!this.customerChoose || this.customerChoice) && (
              <VBtn
                width="90%"
                large
                color="green"
                dark
                class="ma-1"
                onClick={() => this.newItem()}
              >
                <VIcon large>mdi-package-variant-closed</VIcon>
                <VIcon large>mdi-fish</VIcon>
                <VIcon class="ml-2">mdi-plus-thick</VIcon>
              </VBtn>
            )}
          </VCol>
        </VRow>
      </div>
    );

    return (
      <VCard
        color="rgba(255,255,255,.9)"
        width="100%"
        elevation="0"
        class="fill-height ma-0 pa-0"
      >
        {orderPage["orders"]}
      </VCard>
    );
  }
};
